type ApiErrorData = {
  errorCode: string;
  error?: string;
  title?: string;
  message?: string;
  errorMessages: string[];
};

export class ApiError extends Error {
  status: number;
  url?: string;
  request?: RequestInit;
  data?: ApiErrorData;

  constructor(
    message: string,
    {
      status,
      url,
      request,
      data,
    }: {
      status: number;
      url?: string;
      request?: RequestInit;
      data?: ApiErrorData;
    },
  ) {
    super(message);
    this.status = status;
    this.url = url;
    this.request = request;
    this.data = data;

    // Set the prototype explicitly (necessary for extending Error in TypeScript)
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export class ValidationError extends Error {
  data?: unknown;

  constructor(message: string, data?: unknown) {
    super(message);
    this.data = data;

    // Set the prototype explicitly (necessary for extending Error in TypeScript)
    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}
